import { render, staticRenderFns } from "./Bling.vue?vue&type=template&id=0080218b&scoped=true&"
import script from "./Bling.vue?vue&type=script&lang=js&"
export * from "./Bling.vue?vue&type=script&lang=js&"
import style0 from "./Bling.vue?vue&type=style&index=0&id=0080218b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0080218b",
  null
  
)

export default component.exports